import { Injectable } from '@angular/core';
import { ToastController, LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ErrorAndLoadingService {

  genericLoading: HTMLIonLoadingElement;

  constructor(private toastController: ToastController, private loadingCtrl: LoadingController) {
    this.genericLoading = null;
  }

  async presentToastWithDuration(duration: number, position: any, message: string, translucent: boolean) {
    const toast = await this.toastController.create({
      message: message,
      duration: duration,
      keyboardClose: false,
      translucent: translucent,
      animated: true,
      position: position,
      color: 'light',
    });
    toast.present();
  }

  async presentToastWithOptions(message: string, position: any, closeMessage: string, translucent: boolean) {
    const toast = await this.toastController.create({
      message: message,
      position: position,
      keyboardClose: false,
      translucent: translucent,
      animated: true,
      color: 'light',
    });
    toast.present();
  }

  async showLoading() {
    if (!this.genericLoading) {
      this.genericLoading = await this.loadingCtrl.create({
        message: '',
        cssClass: 'loading-container',
      });
      return await this.genericLoading.present();
    }
  }

  async hideLoading() {
    if (this.genericLoading) {
      await this.genericLoading.dismiss();
      this.genericLoading = null;
    }
  }

}
